import { useDashboardFeatureFlags } from '@components/utils/DashboardFeatureFlags'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions'
import { useModalContext } from '@fourthwall/components'
import { ApparelIcon, CartIcon, PostIcon, TagIcon } from '@fourthwall/icons'
import { useCreateProduct } from '@modules/Dashboard/Product/hooks/useCreateProduct'
import { reverse, routing } from '@utils/routing'

import { CreatePromotionModal } from '../../../pages/Promotions/modules/CreatePromotionModal'

export const useQuickActions = () => {
  const { open } = useModalContext()
  const { hasPermission } = useDashboardPermissions()
  const { dashboardFeatureFlags } = useDashboardFeatureFlags()
  const { openCreateProductModal } = useCreateProduct()
  const promotionsPermissions = {
    shopPromoCodes: hasPermission('promotions.shopPromoCodes'),
    membershipsPromoCodes:
      dashboardFeatureFlags.memberships.enabled &&
      hasPermission('promotions.membershipsPromoCodes'),
    giveawayLinks: hasPermission('promotions.giveawayLinks'),
  }

  const promotionsPermissionsCount = Object.values(promotionsPermissions).filter(Boolean).length
  const shouldOpenPromotionsModal = promotionsPermissionsCount > 1

  const handleLaunchPromotionClick = () => open(CreatePromotionModal)

  const getPromotionLink = () => {
    if (!shouldOpenPromotionsModal) {
      if (promotionsPermissions.shopPromoCodes) {
        return reverse(routing.promotions.promotionCodes.create.self)
      }

      if (promotionsPermissions.membershipsPromoCodes) {
        return reverse(routing.promotions.promotionCodes.createMemberships.self)
      }

      if (promotionsPermissions.giveawayLinks) {
        return reverse(routing.promotions.giveawayPackages.create.self)
      }
    }
  }

  const getDropdownItems = () => {
    const dropdownItems = [
      {
        enabled: hasPermission('products.orderSamples'),
        title: 'Place an order',
        icon: CartIcon,
        subtitle: 'Purchase samples or order products for yourself',
        to: reverse(routing.settings.samples.order),
      },
      {
        enabled:
          dashboardFeatureFlags.memberships.enabled && hasPermission('memberships.post.create'),
        title: 'Add post',
        icon: PostIcon,
        subtitle: 'Create more content to engage with your members!',
        to: reverse(routing.memberships.posts.create),
      },
      {
        enabled: hasPermission('products.create'),
        title: 'Create product',
        icon: ApparelIcon,
        subtitle: 'Design a new product or list something you own.',
        onClick: openCreateProductModal,
      },
      {
        enabled: !!promotionsPermissionsCount,
        title: 'Launch promotion',
        icon: TagIcon,
        subtitle: 'Setup promotions to increase your sales.',
        to: getPromotionLink(),
        onClick: shouldOpenPromotionsModal ? handleLaunchPromotionClick : undefined,
      },
    ]

    return dropdownItems.filter((dropdownItems) => dropdownItems.enabled)
  }

  return {
    dropdownItems: getDropdownItems(),
  }
}
